/* eslint-disable */
import React, { Component } from 'react'


import Svg, {
    Circle,
    Ellipse,
    G,
    LinearGradient,
    RadialGradient,
    Line,
    Path,
    Polygon,
    Polyline,
    Rect,
    Symbol,

    Use,
    Defs,
    Stop
} from 'react-native-svg';




export const SvgCloseBlack = ({ size }) => {
    return (<Svg width={size} height={size} viewBox="0 0 438 433">
        <G>
            <Path class="st0" fill="#000000" d="M20.5,349.6L353.3,16.8c18.1-18.1,47.4-18.1,65.5,0l0,0c18.1,18.1,18.1,47.4,0,65.5L86,415.1c-18.1,18.1-47.4,18.1-65.5,0l0,0C2.4,397,2.4,367.7,20.5,349.6z" />
            <Path class="st0" fill="#000000" d="M349.9,416.1L17.1,83.3C-1,65.2-1,35.9,17.1,17.8l0,0c18.1-18.1,47.4-18.1,65.5,0l332.8,332.8c18.1,18.1,18.1,47.4,0,65.5l0,0C397.3,434.2,368,434.2,349.9,416.1z" />
        </G>
    </Svg>)
}
